import { render, staticRenderFns } from "./FavoriteGrid.vue?vue&type=template&id=7b2a125f&scoped=true&"
import script from "./FavoriteGrid.vue?vue&type=script&lang=js&"
export * from "./FavoriteGrid.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteGrid.vue?vue&type=style&index=0&id=7b2a125f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a125f",
  null
  
)

export default component.exports